import service from '@/store/services/contratos-service';

const state = {
  list: {},
  contrato: {},
  meta: {},
  dashboard: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, contrato) => {
    state.contrato = contrato;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_DASHBOARD: (state, dashboard) => {
    state.dashboard = dashboard;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((contrato) => { commit('SET_RESOURCE', contrato); });
  },

  baixarArquivo({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.downloadPDF(params[0],params[1])
        .then((resposta) => {
          // Manipular a resposta, se necessário
          //console.log("PDF baixado com sucesso!", resposta);
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },
  
  erpbaixar({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.erpbaixar(params)
        .then((resposta) => {
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },

  dashboard({ commit, dispatch }) {
    return service.dashboard()
    .then((dashboard) => {commit('SET_DASHBOARD', dashboard); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((contrato) => { commit('SET_RESOURCE', contrato); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((contrato) => { commit('SET_RESOURCE', contrato); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  contrato: state => state.contrato,
  dashboard: state => state.dashboard,
  dropdown: (state) => {
    return state.list.map(contrato => ({
      id: contrato.id,
      name: contrato.codigo,
      codigo: contrato.codigo,
      imovel_id: contrato.imovel?.id,
      inquilino_id: contrato.inquilino?.id,
      tipocontrato_id: contrato.tipocontrato?.id,
      situcontrato_id: contrato.situcontrato?.id,
      imoveltipo_id: contrato.imoveltipo?.id,
      seguroistatu_id: contrato.seguroistatu?.id,
      datainicio: contrato.datainicio,
      valorlocacao: contrato.valorlocacao
    }));
  }
};

const contratos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default contratos;
